package app.nestbridge.feature.invitations.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.feature.invitations.model.InvitationDeliveryMethod
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class SendInvitationScreen(
    val childId: String,
) : Screen

data class SendInvitationState(
    val childDisplayName: String?,
    val selectedMethod: InvitationDeliveryMethod = InvitationDeliveryMethod.PHONE,
    val emailOrPhone: String,
    val isSending: Boolean,
    val errorMessage: String?,
    val eventSink: (SendInvitationEvent) -> Unit,
) : CircuitUiState

sealed interface SendInvitationEvent {
    data object OnAppear : SendInvitationEvent
    data object Back : SendInvitationEvent
    data class SelectMethod(val method: InvitationDeliveryMethod) : SendInvitationEvent
    data class UpdateEmailOrPhone(val value: String) : SendInvitationEvent
    data object SendInvitation : SendInvitationEvent
}

fun SendInvitationState.canSend(): Boolean =
    emailOrPhone.isNotBlank() && !isSending
